import { Trans, useTranslation } from "react-i18next"

export default function AssessorAssignedContent({ events, ownerChallenge }) {
  const allIdeas = events.flatMap((event) => event?.ownerIdeas || [])
  const { t } = useTranslation()

  return (
    <Trans
      i18nKey="notifications.assessorAssigned"
      values={{
        ideaLabel: allIdeas.length > 1 ? t("generic.ideas") : t("generic.idea"),
        ideas: allIdeas.map((idea) => idea?.name || "[Deleted]").join(" "),
        challenge: ownerChallenge?.name || "Deleted",
      }}
      components={{ b: <b /> }}
    />
  )
}
